import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = {
  id: "print-template",
  class: "print-card"
}
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "phone" }

import { PropType, onMounted } from "vue";
import { ProductOrder } from "@/api/models/product_order/ProductOrder";

declare const getLodop: (oOBJECT?: any, oEMBED?: any) => any;


export default /*@__PURE__*/_defineComponent({
  __name: 'DeliveryPrint',
  props: {
  accept: {
    type: Object as PropType<ProductOrder>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

// 声明全局函数和变量
let LODOP: any;

onMounted(() => {
  // 获取 LODOP 对象
  LODOP = getLodop();
  // 设置许可证（根据实际需求替换）
  if (LODOP) {
    LODOP.SET_LICENSES(
      "",
      "EE0887D00FCC7D29375A695F728489A6",
      "C94CEE276DB2187AE6B65D56B3FC2848",
      ""
    );
  }
});

const handlePrint = () => {
  if (!LODOP) {
    alert("无法获取 LODOP 对象，请检查 CLodop 服务");
    return;
  }
  const strHTML = document.getElementById("print-template")!.innerHTML;
  LODOP.PRINT_INITA(0, 0, 78, 49, "热敏纸打印");
  LODOP.SET_PRINTER_INDEXA("KM-118M");
  LODOP.SET_PRINT_PAGESIZE(1, "79mm", "50mm", "");
  LODOP.ADD_PRINT_HTM(0, 0, "79mm", "50mm", strHTML);
  LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true);
  LODOP.PRINT();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "prefix" }, "收", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(__props.accept.recipient_province) + _toDisplayString(__props.accept.recipient_city) + _toDisplayString(__props.accept.recipient_district) + _toDisplayString(__props.accept.recipient_address) + " " + _toDisplayString(__props.accept.recipient_postcode
                ? `(邮编:${__props.accept.recipient_postcode})`
                : ""), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.accept.recipient_name) + " (收)", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "prefix" }, "寄", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString(__props.accept.send_province) + _toDisplayString(__props.accept.send_city) + _toDisplayString(__props.accept.send_district) + _toDisplayString(__props.accept.send_address), 1),
          _createElementVNode("p", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(__props.accept.send_phone), 1),
            _createTextVNode(_toDisplayString(__props.accept.send_name) + " (寄) " + _toDisplayString(__props.accept.relationship ? `(关系:${__props.accept.relationship})` : ""), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("button", {
      onClick: handlePrint,
      class: "print-button"
    }, "打印")
  ]))
}
}

})